import React, { useState, useRef } from 'react';
import {SIGNUP_URL,RECAPTCHA_SITE_KEY} from '../../Config/AppConfiguration';
import { useNavigate} from 'react-router-dom';
import { Spinner } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import  ReCAPTCHA  from 'react-google-recaptcha';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PhoneInput, {
  isValidPhoneNumber
} from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './JoinUs.css';

const JoinUs = () => {

    const [emailId, setEmailId] = useState('');
    const [name, setName] = useState('');
    const [surName, setSurName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [captchaStatus, setCaptchaStatus] = useState({ success: false, message: '' });
    const [recaptchaValue, setRecaptchaValue] = useState('');
    const [modalShow, setModalShow] = React.useState(false);
    const [isCreateButtonActive, setIsCreateButtonActive] = useState(false);
    const [accountActivationConfirmationMsg, setAccountActivationConfirmationMsg] = useState("");


  const navigate = useNavigate();
  const navigateHome = () => {
    navigate('/');
  };
  let captchaReference = useRef()
  
    console.log("PHONE NUMBER ---"+phoneNumber)
    console.log("emailId ---"+emailId)
    console.log("name ---"+name);
    console.log("surname ---"+surName);
     // create a reset function
  const resetRecaptcha = () => {
    captchaReference.reset();
  };
    const onChange = (value) => {
      setRecaptchaValue(value);
    };

      console.log("recaptcha response===>"+recaptchaValue);
      function MyVerticallyCenteredModal(props) {
        return (
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            animation={false}
            backdrop='static' 
            keyboard="False"
            dialogClassName='my-modal'
          >
            <Modal.Header className='modal-header'>
              <Modal.Title id="contained-modal-title-vcenter">
              Confirmation Of Account Creation
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className='modal-body'>
              <p>
                {"Account is successfully created, "+accountActivationConfirmationMsg}
              </p>
            </Modal.Body>
            <Modal.Footer>
            <button className="ui button comm-button-style primary" onClick={navigateHome}>OK</button>
            </Modal.Footer>
          </Modal>
        );
      }
      const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isValidPhoneNumber(phoneNumber)) {
          toast.error('Please enter a valid phone number');
          return;
        }
        setIsCreateButtonActive(true);
        const userDetailsObject = {
          name,
          surName,
          email: emailId,
          mobile: phoneNumber
        };

        const customAxios = axios.create();

        try {
            const response = await customAxios.post(
                SIGNUP_URL,
                userDetailsObject,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'g-recaptcha-response': recaptchaValue
                    },
                    withCredentials: true 
                }
            );
            if (response && response.status === 200) {
                setAccountActivationConfirmationMsg(response.data.message);
                setIsCreateButtonActive(false); 
                setModalShow(true);
                resetRecaptcha();
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setAccountActivationConfirmationMsg("User already exists in the system.");
                setIsCreateButtonActive(false);
                setModalShow(true);
                toast.error("User already exists in the system.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 8000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                    
                });
            } else {
                console.log(error);
            }
        } finally {
          setIsCreateButtonActive(false);
        }
      }
      const isFormValid = emailId?.trim() && name?.trim() && surName?.trim() && recaptchaValue && phoneNumber && isValidPhoneNumber(phoneNumber);

        return (
          <div
            id="joinUsContainer"
            className="joinus-page-bg"
          >
            <div className="joinus-header">
              <h1>JOIN US</h1>
            </div>
            <div className="joinus-main-content">
              <section className="join-us-wrap">
                <ul className="signup-elements-wrap mt-2">
                  <li>
                    <div className="custom-input-wrapp">
                      <FloatingLabel
                        controlId="emailIdJU"
                        label="Email Id"
                        className="inputText"
                        autoComplete="off"
                        onChange={(event) => setEmailId(event.target.value)}
                      >
                        <Form.Control
                          type="email"
                          placeholder="name@example.com"
                          maxLength={240}
                        />
                        <span className="input-info-label">
                          Eg: username@domain.com
                        </span>
                        <span className="required-field-op">(Required)</span>
                        <span
                          className="form-error error-message-show"
                          style={{ visibility: "hidden" }}
                        >
                          Email Id is invalid
                        </span>
                      </FloatingLabel>
                    </div>
                  </li>
                  <li>
                    <div className="name-surname-row">
                      <div className="custom-input-wrapp name-input">
                        <FloatingLabel
                          controlId="nameJU"
                          label="Name"
                          className="inputText"
                          autoComplete="off"
                          onChange={(event) => setName(event.target.value)}
                        >
                          <Form.Control
                            type="text"
                            placeholder="Name"
                          />
                          <span className="input-info-label">
                            Eg: John
                          </span>
                          <span className="required-field-op">(Required)</span>
                          <span
                            className="form-error error-message-show"
                            style={{ visibility: "hidden" }}
                          >
                            Name is invalid
                          </span>
                        </FloatingLabel>
                      </div>
                      <div className="custom-input-wrapp surname-input">
                        <FloatingLabel
                          controlId="surnameJU"
                          label="Surname"
                          className="inputText"
                          autoComplete="off"
                          onChange={(event) => setSurName(event.target.value)}
                        >
                          <Form.Control
                            type="text"
                            placeholder="Surname"
                          />
                          <span className="input-info-label">
                            Eg: Doe
                          </span>
                          <span className="required-field-op">(Required)</span>
                          <span
                            className="form-error error-message-show"
                            style={{ visibility: "hidden" }}
                          >
                            Surname is invalid
                          </span>
                        </FloatingLabel>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="contact-num-wrap pe-2">
                      <div class="country-code-w">
                        
                        <div className="phone-input-wrapper">
  <PhoneInput
    international
    value={phoneNumber}
    onChange={(value) => {
      setPhoneNumber(value || '');
    }}
    placeholder="Enter phone number"
  />
</div>
                        <span className="required-field-op">(Required)</span>
                      </div>
                    </div>
                    <span
                      className="form-error error-message-show"
                      style={{ visibility: "hidden" }}
                    >
                      Mobile number is invalid
                    </span>
                  </li>
                  <li className="custom-input-wrapp">
                    <div id="captcha_joinus_element">
                      <ReCAPTCHA
                      sitekey={RECAPTCHA_SITE_KEY}
                      onChange={onChange}
                        ref={(e) => (captchaReference = e)}
                      />
                    </div>
                  </li>

                  <p>{captchaStatus.message}</p>
                  <li
                    className="min-marg privacy-policy-txt"
                    style={{ display: "none" }}
                  >
                    <p>
                      By signing up you are indicating that you have read &amp;
                      agree to the
                      <a
                        href="../../SiteAssets/APIMarketplace/Gfx/Privacy-Notice-API-Market-Place.pdf"
                        target="_blank"
                      >
                        Privacy Policy
                      </a>
                      .
                    </p>
                  </li>
                  <li>
                    <p>
                      Note: An activation link will be send to your registered
                      mail id, Please click the link to activate.
                    </p>
                  </li>
                  <li>
                    <div className="apim-pop-button-w comm-button-wrap">
                      <button
                        className="ui button comm-button-style primary apim-pop-button-create"
                        id="createJU"
                        onClick={handleSubmit}
                        disabled={!isFormValid || isCreateButtonActive}
                      >
                        
                           {!isCreateButtonActive?<>CREATE</>:
                            <div style={{ display: 'block'}}> 
                           <Spinner animation="border" variant="primary"  style={{ width: 15, height: 15 , marginRight: 5}} /> 
                           JOINING...
                          </div> 
                           } 
                      </button>
                      <button
                        className="ui button comm-button-style secondary custom-loader"
                        id="loadingJU"
                        style={{ display: "none" }}
                      >
                        <i className="icon-plus iconLoader" />
                        Joining..
                      </button>

                     
                      <span className="visually-hidden">Loading...</span>
                      <MyVerticallyCenteredModal
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                      />
                      <button
                        className="ui button comm-button-style secondary apim-pop-button-cancel"
                        id="cancelJU"
                        formNoValidate
                        onClick={navigateHome}
                      >
                        Cancel
                      </button>
                    </div>
                  </li>
                </ul>
              </section>
            </div>
            {/* ✅ Using global ToastContainer from App.js - removed local instance */}
          </div>
        );
    
}

export default JoinUs;





